export function verifyEnvVar(name: ENV_VARS): string {
  if (typeof process.env[name] === 'string') {
    return process.env[name] as string;
  } else {
    throw new Error(`Expected string type but received undefined for process.env.${name}`);
  }
}

export enum ENV_VARS {
  STRIPE_PUBLIC_KEY = 'STRIPE_PUBLIC_KEY',
  GTM_AUTH = 'GTM_AUTH',
  GTM_PREVIEW = 'GTM_PREVIEW'
}
